import { Button } from '@app/components/various/Button';
import { DropdownMenu } from '@app/components/various/Dropdown';
import { useDropdownContext } from '@app/components/various/Dropdown/context/DropdownContext';
import { DropdownDrawer } from '@app/components/various/Dropdown/DropdownDrawer';
import { ChevronDown } from '@app/components/various/Icons';
import { Portal } from '@app/components/various/Portal';
import { Search } from '@app/components/various/Search';
import { useAmplitude } from '@app/utils/analytics/useAmplitude';
import { useModalVisibility } from '@app/utils/hooks';
import { useAvailableOrderDetails } from '@app/utils/hooks/useAvailableOrderDetails';
import { isDefined } from '@app/utils/is';
import { Dropdown } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OrderSummary } from '../OrderSummary';

import { OrderSelectMenu } from './OrderSelectMenu';
interface Props {
  items: Dropdown.MenuItem[];
}
export const OrderOptionsDrawer = ({ items }: Props) => {
  const { t } = useTranslation(['common', 'selections']);
  const { activeParentItemKey, closeDropdown, setActiveParentItemKey } = useDropdownContext();
  const { showModal } = useModalVisibility('CreateOrderModal');
  const { trackEvent } = useAmplitude();
  const { orderNumber, orderName, accountName, buyerFirstName, buyerLastName } = useAvailableOrderDetails();

  const [search, setSearch] = React.useState('');

  const handleDrawerBack = () => {
    setActiveParentItemKey(null);
    setSearch('');
  };

  const handleCreateSelectionClick = () => {
    closeDropdown();
    showModal();
    trackEvent({ name: 'bottomBar.button.createselection.click' });
  };

  const handleChangeSelectionClick = () => {
    setActiveParentItemKey('changeSelection');
    trackEvent({ name: 'bottomBar.select.selection.click' });
  };

  return (
    <>
      <div className="mb-5 flex flex-col gap-5 rounded-regular bg-neutral-96 px-3 py-2">
        <button type="button" className="flex w-full items-center gap-4 rounded-regular text-left" onClick={handleChangeSelectionClick}>
          <span className="flex flex-1 flex-col gap-1">
            <span className="body-1">
              #{orderNumber} {orderName}
            </span>
            <span data-sentry-mask className="text-neutral-40 body-4">
              {buyerFirstName} {buyerLastName} ({accountName})
            </span>
          </span>
          <ChevronDown className="shrink-0 -rotate-90 text-neutral-40" />
        </button>
        <Portal>
          <DropdownDrawer
            title="Change selection"
            isOpen={isDefined(activeParentItemKey)}
            isNested
            className="h-full"
            onBack={handleDrawerBack}
            onClose={closeDropdown}
          >
            <Search value={search} placeholder={t('selections:search_selection')} isFluid className="mb-3" onChange={setSearch} />
            <OrderSelectMenu search={search} onOptionClick={closeDropdown} />
          </DropdownDrawer>
        </Portal>
        <OrderSummary />
      </div>
      <DropdownMenu items={items} />
      <div className="mt-5 border-t border-neutral-90 pt-5">
        <Button isFluid onClick={handleCreateSelectionClick}>
          {t('selections:create_selection')}
        </Button>
      </div>
    </>
  );
};
